
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { EvaStatus } from '@/types/resource.types';

@Component({
    name: 'EvaStatusChip',
})
export default class EvaStatusChip extends Vue {

    /* Props
    ============================================*/

    @Prop({ type: Number, required: true })
    readonly evaStatus: EvaStatus;

    /* Computed
    ============================================*/

    get visible(): boolean {
        return this.evaStatus === EvaStatus.Pending
            || this.evaStatus === EvaStatus.Running
            || this.evaStatus === EvaStatus.Error;
    }

    get color(): string {
        switch (this.evaStatus) {
            case EvaStatus.Pending:
            case EvaStatus.Running:
                return 'primary';
            case EvaStatus.Error:
                return 'error';
            default:
                return '';
        }
    }

    get icon(): string {
        switch (this.evaStatus) {
            case EvaStatus.Pending:
            case EvaStatus.Running:
                return 'mdi-brain';
            case EvaStatus.Error:
                return 'mdi-alert';
            default:
                return '';
        }
    }

    get statusText(): string {
        switch (this.evaStatus) {
            case EvaStatus.Pending:
            case EvaStatus.Running:
                return 'EVA Running';
            case EvaStatus.Error:
                return 'EVA Error';
            default:
                return '';
        }
    }

}
